import axios from 'axios';
import {
  Message,
  Loading
} from 'element-ui';
let loadingCount = 0;
let loading;
axios.defaults.timeout = 50000;

function refreshToken() {
  // instance是当前request.js中已创建的axios实例
  if (!localStorage.getItem('refresh_token')) {
    return
  }
  return post('/User/refresh', {
    refresh_token: localStorage.getItem('refresh_token')
  }).then(res => res.data)
}


var flag  = false;

if (flag) {
  axios.defaults.baseURL = '/test/api';
  // axios.defaults.baseURL = 'https://world.pingyao888.cn/api'
} else {
  axios.defaults.baseURL = 'https://world.pingyao888.cn/api'
  // axios.defaults.baseURL  = 'http://shoot.pingyao888.cn/api'
}

let isRefreshing = true
const requests = []

//http request 拦截器
axios.interceptors.request.use(
  config => {
	  console.log(config);
    var AccessToken = localStorage.getItem('access_token');
    // config.data = JSON.stringify(config.data);
    var lang = localStorage.getItem('languageSet');

    var langs;
    if (lang) {
      if (lang == 'zh') {
        langs = 'en'
      } else {
        langs = 'cn'
      }
    } else {
      langs = 'cn'
    }
    config.headers = {
      "Access-Token":AccessToken,
      "lang": langs
    }

    if (localStorage.getItem('languageSet') == 'zh') {
      if (config.url != 'order/payStatus') {
        loading = Loading.service({
          lock: true,
          text: 'Loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }
    } else {
      // 如果不是 微信 查看是否支付 接口
      if (config.url != 'order/payStatus') {
        loading = Loading.service({
          lock: true,
          text: '加载中……',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }
    }

    return config;
  },
  error => {
    // 此处处理请求错误
	 loading.close();
     Message.error('服务器异常');
    return Promise.reject(error);
  }
);
let isFa = false;
//http response 拦截器
axios.interceptors.response.use(
  response => {
    loading.close();
    if (response.data.code == 400) {
      Message.error(response.data.message)
    }
         const config = response.config;
    if(config.url != 'cart/list'){
      if(response.data.code == 900){
          Message.error('暂不支持英文版本商城')
          setTimeout(()=>{
            location.href = 'http://shoot-html.pingyao888.cn/pc_web/#/'
          },2000)
      }
    }

    if (response.data.code == 401) {
		console.log('asdawdsadad')
		// if(!window.localStorage.getItem('access_token')){
		// 	Message.error('请先登录')
		// 	return false
		// }
      // 获取当前失败的请求
      const config = response.config;
      console.log(isRefreshing)
      if (!isRefreshing) {

        return refreshToken().then(res => {
          console.log(res);

          var access_token = res.access_token;
          localStorage.setItem('access_token', access_token);
          config.headers['Access-Token'] = access_token;
          if (res.code == 401) {
            Message.error('请先登录');
            window.location.href = 'http://shoot-html.pingyao888.cn/pc_web/#/'
          }
          isRefreshing = true;
          return axios(config)
        }).catch(res => {
			console.log(12323123)
          console.error('refreshtoken error =>', res)
          // 刷新token 失败重新登录
          Message.error('请重新登录');
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('userInfo');
          isRefreshing = false;
          window.location.href = 'http://shoot-html.pingyao888.cn/pc_web/#/'
        }).finally(() => {
          isRefreshing = false
        })
      } else {
        return new Promise((resolve) => {
          // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
          requests.push((access_token) => {

            config.headers['Access-Token'] = access_token
            resolve(axios(config))
          })
        })
      }
    }
    return response;
  },
  error => {
    // 处理错误请求
    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          console.log('未登录');
        case 400:
          console.log(error.response)
        default:
          error.message = `连接错误${error.response.status}`
      }
    } else {
      // 超时处理
      if (JSON.stringify(error).includes('timeout')) {
        Message.error('服务器响应超时，请刷新当前页')
      }
      error.message('连接服务器失败')
    }
    return Promise.reject(error.response)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/utils/http.js